import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { ICreateSubGroup, IGetSubGroupFilters, ISubGroup, IUpdateSubGroup } from '../../../../pages/management/services/service-subgroups/interface/subgroups.interface';

@Injectable({
  providedIn: 'root',
})
export class ServiceSubGroupsService {
  constructor(private readonly apiService: ApiService) {}

  create(data: ICreateSubGroup) {
    return this.apiService.post<ISubGroup>('service-subgroups/create', data);
  }
  update(data: IUpdateSubGroup) {
    return this.apiService.patch<ISubGroup>(
      'service-subgroups/update',
      data
    );
  }
  delete(id: number) {
    return this.apiService.delete<{success:boolean}>(
      `service-subgroups/delete/${id}`,
    );
  }
  getAll(data: IGetSubGroupFilters) {
    return this.apiService.post<ISubGroup[]>(
      'service-subgroups/getAll',
      data
    );
  }
}
